shadow$provide[453] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying vec2 vST;

vec4 getSample(vec2 st);

vec4 getSTSample() {
  return getSample(vST);
}
`;

};